import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  plugins,
} from "chart.js";

// Register required Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface ChartData {
  x: string[]; // Years
  y: number[]; // Values
}

interface LineChartProps {
  data: ChartData;
}


//DELETE LATER
function isEmptyObject(obj: Record<string, any>): boolean {
  return obj !== null && typeof obj === 'object' && Object.keys(obj).length === 0;
}


const TimeSeriesChart: React.FC<LineChartProps> = ({ data }) => {

  if(isEmptyObject(data)) return <></>;


  const chartData = {
    labels: data.x.map((year) => year.toString()), // Convert years to string for labels
    datasets: [
      {
        label: "Value",
        data: data.y,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        tension: 0.4, // Smooth line
        pointRadius: 5,
        pointBackgroundColor: "rgba(75, 192, 192, 1)",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
    },
    scales: {
      x: { title: { display: true, text: "Year" } },
      y: { title: { display: true, text: "Value" } },
    },
  };

  return <Line data={chartData} options={options} />;
};

export default TimeSeriesChart;